// @flow
import { isItemSaved, toggleItemSave } from '../../redux/modules/saveItem';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getSavedItemCount } from '../../redux/modules/savedItemCount';
import isEqual from 'react-fast-compare';
import { isUserLoggedIn } from '../../redux/modules/user';
import ItemSaveButton from './ItemSaveButton';
import ItemSaveIcon from './ItemSaveIcon';
import noop from '../../utils/noop';
import ShouldLogInContainer from '../../components/ShouldLogIn/ShouldLogInContainer';

const mapStateToProps = (state, { itemId }) => {
    const saved = isItemSaved(state, itemId);
    const savedCount = getSavedItemCount(state, itemId).savedCount;
    return {
        saved,
        savedCount,
        userLoggedIn: isUserLoggedIn(state),
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            toggleItemSave,
        },
        dispatch
    );

type Props = {
    button: boolean,
    buttonClassName: string,
    className: string,
    iconClassName: string,
    itemId: number,
    saved: boolean,
    savedCount: number,
    showSavedCount: boolean,
    toggleItemSave: Function,
    userLoggedIn: boolean,
};

class ItemSaveContainer extends Component<Props> {
    static defaultProps = {
        button: false,
        buttonClassName: '',
        className: '',
        iconClassName: '',
        itemId: 0,
        saved: false,
        savedCount: 0,
        showSavedCount: false,
        userLoggedIn: false,
    };

    shouldComponentUpdate = nextProps => !isEqual(this.props, nextProps);

    onToggleSave = () => {
        this.props.toggleItemSave(this.props.itemId);
    };

    render() {
        const {
            button,
            buttonClassName,
            className,
            iconClassName,
            saved,
            savedCount,
            showSavedCount,
            userLoggedIn,
        } = this.props;

        return (
            <ShouldLogInContainer forceSignUp={!userLoggedIn} runFunction={this.onToggleSave}>
                <div className={className}>
                    {button ? (
                        <ItemSaveButton
                            className={buttonClassName}
                            save={noop}
                            saved={userLoggedIn && saved}
                            savedCount={savedCount}
                            showSavedCount={showSavedCount}
                        />
                    ) : (
                        <ItemSaveIcon className={iconClassName} save={noop} saved={userLoggedIn && saved} />
                    )}
                </div>
            </ShouldLogInContainer>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ItemSaveContainer);
